import styles from "./ArtObjectDetailsInfo.module.scss";

const ArtObjectDetailsInfo = ({
  inventoryNo = "-",
  warehouseName = "-",
  orderInDate = "-",
  imageUrl = "",
  showImage = true
}) => {
  return (
    <div className={styles.objectDetailsInfo}>
      <div>
        <p>Inventory No</p>
        <p>{inventoryNo}</p>
      </div>
      <div>
        <p>Warehouse</p>
        <p>{warehouseName}</p>
      </div>
      <div>
        <p>Date in</p>
        <p>{orderInDate}</p>
      </div>
      {showImage && (
        <div className={styles.imageContainer}>
          {imageUrl ? (
            <img
              className={styles.imagePlaceholder}
              src={imageUrl}
              alt="Object"
            />
          ) : (
            <div className={styles.imagePlaceholder}>Image</div>
          )}
        </div>
      )}
    </div>
  );
};

export default ArtObjectDetailsInfo;
